import React from 'react';
import {OrderType, PromotionApi} from "../../../../services/Api/types";
import {useTranslation, withTranslation} from "react-i18next";
import ItemHelper from "../../../../services/Menu/services/Item/ItemHelper";
import Money from "../../../Common/Money";
import {RootState} from "../../../../../reducers";
import {getCategories, getItems} from "../../../../services/Menu/reducer";
import {connect} from "react-redux";

interface OwnProps {
    promotion: PromotionApi;
}

type Props = ReturnType<typeof mapStateToProps> & OwnProps;

const PromotionInfoForOldVersion = ({promotion, categories, items}: Props) => {
    const {t} = useTranslation();

    const renderTypes = () => {
        const types: OrderType[] = [];

        if (promotion?.dine_in) {
            types.push(OrderType.DINE_IN);
        }
        if (promotion?.delivery) {
            types.push(OrderType.DELIVERY);
        }
        if (promotion?.takeaway) {
            types.push(OrderType.PICK_UP);
        }
        if (promotion?.room_service) {
            types.push(OrderType.ROOM_SERVICE);
        }
        if (types.length <= 0) {
            return undefined;
        }

        return types.map(type => t("enums.order.type." + type));
    }

    const getConditions = (conditions: Record<string, any>[]) => {
        return conditions.map((condition) => {
            if (condition.type == "ITEM") {
                let item = ItemHelper.getItem(items, condition.entity_id);

                if (!item) return undefined;

                return item.translation.name;
            }
            if (condition.type == "CATEGORY") {
                let category = categories.filter((categoryItem: any) => categoryItem.id === condition.entity_id)[0];

                if (!category) return undefined;

                return category.translation.name;
            }

            return undefined;
        }).filter(Boolean);
    }

    const types = renderTypes();

    return (
        <dl>
            {types && (
                <div>
                    <dt>
                        {t("modules.promotion.field.order_type.title")}
                    </dt>
                    <dd>
                        <ul>
                            {
                                types.map((type: string) => (
                                    <li key={type}>{type}</li>
                                ))
                            }
                        </ul>
                    </dd>
                </div>
            )}
            {promotion.min_basket_money && (
                <div>
                    <dt>{t("common.word.min_order_price")}</dt>
                    <dd>
                        <ul>
                            <li>
                                <Money value={promotion.min_basket_money}/>
                            </li>
                        </ul>
                    </dd>
                </div>
            )}

            {promotion.min_condition_quantity && (
                <div>
                    <dt>
                        {t("modules.promotion.field.min_positions_amount.title")}
                    </dt>
                    <dd>
                        <ul>
                            <li>
                                {promotion.min_condition_quantity}
                            </li>
                        </ul>
                    </dd>
                </div>
            )}
            {(promotion.conditions && promotion.conditions.length > 0) && (
                <div>
                    <dt>
                        {t("modules.promotion.field.required_positions.title")}
                    </dt>
                    <dd>
                        <ul>
                            {getConditions(promotion.conditions).map((condition: any, index: any) => {
                                return (
                                    <li key={index}>
                                        {condition}
                                    </li>
                                )
                            })}
                        </ul>
                    </dd>
                </div>
            )}
        </dl>
    )
}

const mapStateToProps = (state: RootState) => ({
    items: getItems(state.menu),
    categories: getCategories(state.menu),
});

const connector = connect(mapStateToProps);
export default withTranslation()(connector(PromotionInfoForOldVersion));